import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const GalleryPage = lazy(() => import('../pages/galeri/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service Detail Pages
const SuKacagiTespitiPage = lazy(() => import('../pages/services/su-kacagi-tespiti/page'));
const DogalgazTesisatPage = lazy(() => import('../pages/services/dogalgaz-tesisat/page'));
const IsitmaSogutmaYanginPage = lazy(() => import('../pages/services/isitma-sogutma-yangin/page'));
const PaslanmazArgonKaynagiPage = lazy(() => import('../pages/services/paslanmaz-argon-kaynagi/page'));
const GiderAcmaTikaniklikPage = lazy(() => import('../pages/services/gider-acma-tikaniklik/page'));
const SifonikSistemlerPage = lazy(() => import('../pages/services/sifonik-sistemler/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/hizmetler/su-kacagi-tespiti',
    element: <SuKacagiTespitiPage />,
  },
  {
    path: '/hizmetler/dogalgaz-tesisat',
    element: <DogalgazTesisatPage />,
  },
  {
    path: '/hizmetler/isitma-sogutma-yangin',
    element: <IsitmaSogutmaYanginPage />,
  },
  {
    path: '/hizmetler/paslanmaz-argon-kaynagi',
    element: <PaslanmazArgonKaynagiPage />,
  },
  {
    path: '/hizmetler/gider-acma-tikaniklik',
    element: <GiderAcmaTikaniklikPage />,
  },
  {
    path: '/hizmetler/sifonik-sistemler',
    element: <SifonikSistemlerPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/galeri',
    element: <GalleryPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;